import { ViewContainerRef, TemplateRef, OnInit, Directive, OnDestroy } from '@angular/core';
import { MediaService } from '~shared/services/media.service';
import { MediaAlias } from '~shared/models/media.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive()
export abstract class AbstractVisibilityClassDirective implements OnInit, OnDestroy {

  public abstract targetMediaAlias: MediaAlias;
  private isTemplateShowed: boolean;
  private destroy$ = new Subject<void>();

  constructor(
    protected templateRef: TemplateRef<any>,
    protected viewContainer: ViewContainerRef,
    protected mediaService: MediaService,
  ) {}

  public ngOnInit(): void {
    this.mediaService.mediaAliases$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => {
      const isMediaAliasActive = this.mediaService.isAliasActive(this.targetMediaAlias);
      this.onMediaChange(isMediaAliasActive);
    });
  }

  protected abstract onMediaChange(isMediaAliasActive: boolean): void;

  protected showTemplate(): void {
    if (!this.isTemplateShowed) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isTemplateShowed = true;
    }
  }

  protected hideTemplate(): void {
    if (this.isTemplateShowed) {
      this.viewContainer.clear();
      this.isTemplateShowed = false;
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
